/**
@jsxRuntime
classic */
/** @jsx jsx */
import {jsx} from '@emotion/core'
import {NewCouponForm} from '../components/coupons/new-coupon-form'

function NewCoupon() {
  return <NewCouponForm />
}

export {NewCoupon}
